import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightSvg } from '~/svg';
import { listSavedReports, SavedReport } from '~/services/reports';

const REPORT_TYPE_LABELS: Record<string, string> = {
    campaign_search: 'Client Campaigns',
    patient_campaign: 'Patient Campaign',
    campaign_request: 'Campaign Request',
    medical_professional: 'Medical Professional',
    team_member: 'Team Member',
};

const formatDate = (iso: string) => {
    try {
        return new Date(iso).toLocaleDateString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
        });
    } catch {
        return iso;
    }
};

const SavedSearches = () => {
    const [reports, setReports] = useState<SavedReport[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        listSavedReports({ page: 1 })
            .then((data) => setReports(data.results.slice(0, 5)))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className='mb-4 h-full rounded-sm border border-stroke bg-white p-4 shadow-default dark:border-strokedark dark:bg-boxdark md:p-6 xl:p-7.5'>
            <div className='mb-4 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between'>
                <h2 className='text-xl font-semibold text-black dark:text-white'>
                    Saved Searches
                </h2>

                <Link
                    to='/saved-reports'
                    className='flex items-center gap-2 text-primary'
                >
                    View All <ArrowRightSvg />
                </Link>
            </div>

            {loading ? (
                <div className='flex items-center justify-center py-8'>
                    <div className='h-8 w-8 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent' />
                </div>
            ) : reports.length === 0 ? (
                <div className='flex flex-col items-center gap-4 py-8 text-center'>
                    <p className='text-secondary'>No saved searches yet.</p>
                    <Link
                        to='/new-report'
                        className='inline-flex items-center gap-2 rounded-full border-[2px] border-warning bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-black transition-colors duration-500 hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
                    >
                        Create a Search
                    </Link>
                </div>
            ) : (
                <div className='flex flex-col gap-2'>
                    <div className='grid grid-cols-12 py-2'>
                        <div className='col-span-5'>
                            <p className='text-sm text-secondary'>Search</p>
                        </div>
                        <div className='col-span-4'>
                            <p className='text-sm text-secondary'>Type</p>
                        </div>
                        <div className='col-span-3'>
                            <p className='text-right text-sm text-secondary'>
                                Created
                            </p>
                        </div>
                    </div>
                    {reports.map((report) => (
                        <div key={report.id} className='relative z-1 grid grid-cols-12 py-2'>
                            <div className='col-span-5'>
                                <Link
                                    to={`/saved-reports`}
                                    className='text-primary hover:underline'
                                >
                                    {report.name}
                                </Link>
                            </div>
                            <div className='col-span-4'>
                                <p>{REPORT_TYPE_LABELS[report.report_type] ?? report.report_type}</p>
                            </div>
                            <div className='col-span-3'>
                                <p className='text-right'>{formatDate(report.created_date)}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SavedSearches;
